import { translate } from "app/filters/i18nFilter";

import { EmptyStateStyled } from "./StyledComponents";

export const ShortEmptyState = ({ isError, minHeight }: { isError: boolean; minHeight?: number }) => {
    return (
        <EmptyStateStyled
            title={translate(
                isError
                    ? "ad.intelligence.overview.widget.error.state.title"
                    : "ad.intelligence.overview.widget.empty.state.title",
            )}
            subtitle={translate(
                isError
                    ? "ad.intelligence.overview.widget.error.state.subtitle"
                    : "ad.intelligence.overview.widget.empty.state.short.subtitle",
            )}
            SvgImage={() => null}
            $gridSpan={1}
            $minHeight={minHeight}
        />
    );
};
